import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { Paperclip } from 'angular-feather/icons';
import { Home } from 'angular-feather/icons';
import { Clipboard } from 'angular-feather/icons';
import { Layout } from 'angular-feather/icons';
import { LogOut } from 'angular-feather/icons';
import { Check } from 'angular-feather/icons';
import { DollarSign } from 'angular-feather/icons';
import { Package } from 'angular-feather/icons';
import { HardDrive } from 'angular-feather/icons';
import { Users } from 'angular-feather/icons';
import { Bell } from 'angular-feather/icons';
import { PlusSquare } from 'angular-feather/icons';
import { Info } from 'angular-feather/icons';
import { BarChart2 } from 'angular-feather/icons';
import { Filter } from 'angular-feather/icons';
import { Folder } from 'angular-feather/icons';
import { ArrowRight } from 'angular-feather/icons';
import { ArrowLeft } from 'angular-feather/icons';
import { Trash2 } from 'angular-feather/icons';
import { Eye } from 'angular-feather/icons';
import { Settings } from 'angular-feather/icons';
import { Edit2 } from 'angular-feather/icons';
import { Plus } from 'angular-feather/icons';
import { BarChart } from 'angular-feather/icons';
import { ExternalLink } from 'angular-feather/icons';
import { Lock } from 'angular-feather/icons';
import { CheckCircle } from 'angular-feather/icons';
import { XCircle } from 'angular-feather/icons';
import { AlertTriangle } from 'angular-feather/icons';
import { RefreshCw } from 'angular-feather/icons';

const icons = {
  Paperclip,
  Home,
  Clipboard,
  Layout,
  LogOut,
  Check,
  CheckCircle,
  DollarSign,
  Package,
  HardDrive,
  Users,
  Bell,
  PlusSquare,
  Info,
  BarChart2,
  BarChart,
  Filter,
  Folder,
  ArrowRight,
  ArrowLeft,
  Trash2,
  Eye,
  Settings,
  Edit2,
  Plus,
  ExternalLink,
  Lock,
  XCircle,
  AlertTriangle,
  RefreshCw
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FeatherModule.pick(icons)
  ],
  exports: [
    FeatherModule
  ]
})
export class IconsModule { }
